import { useMutation } from '@tanstack/react-query';
import { userService } from '../../services/userService';

export const useResendChangeEmail = () => {
  return useMutation({
    mutationFn: () =>
      userService.resendChangeEmailCode().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return { success: true, error: null };
        }
        return { success: false, error: data.message };
      }),
  });
};
